import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const FIELDS = [["name", "Company name"], ["abn", "ABN"], ["phone", "Phone"], ["email", "Email"], ["website", "Website"], ["quote_validity_days", "Quote validity (days)", "number"]];

export const CompanySettings = () => {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setF(r.data)); }, []);
  if (!f) return null;

  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/settings", { ...f, quote_validity_days: Number(f.quote_validity_days) }); toast.success("Settings saved"); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <form onSubmit={save} className="grid gap-4 rounded-lg border border-slate-200 bg-white p-6 sm:grid-cols-2" data-testid="company-settings-form">
      <p className="text-sm text-slate-500 sm:col-span-2">These details appear on every quote PDF.</p>
      {FIELDS.map(([k, l, t]) => (
        <div key={k}><Label>{l}</Label><Input type={t || "text"} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1.5" data-testid={`settings-${k}-input`} /></div>
      ))}
      <div className="sm:col-span-2"><Label>Address</Label><Textarea rows={2} value={f.address} onChange={(e) => setF({ ...f, address: e.target.value })} className="mt-1.5" data-testid="settings-address-input" /></div>
      <div className="sm:col-span-2"><Label>Quote terms (footer)</Label><Textarea rows={3} value={f.quote_terms} onChange={(e) => setF({ ...f, quote_terms: e.target.value })} className="mt-1.5" data-testid="settings-terms-input" /></div>
      <div className="sm:col-span-2"><Button type="submit" className="bg-[#01195D] hover:bg-[#0A2A7A]" data-testid="settings-save-btn">Save settings</Button></div>
    </form>
  );
};
